var enLang = {
	"Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn": "Login or Registration with your phone number",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Please input OTP sent to your phone number {{phone}} to login",
	"Đã gửi mã OTP": "Sent OTP code",
	"Đã gửi lại mã OTP": "Resent OTP code",
	"Nhập số điện thoại": "Input phone number",
	"Gửi": "Send",
	"Gửi lại mã": "Resend code",
	"Gửi lại mã sau {{countDownTime}}s": "Resend code after {{countDownTime}}s",
	"Gửi lại mã sau {{countdownMin}}p": "Resend code after {{countdownMin}}m",
	"Gửi lại mã sau {{countdownMin}}p{{countdownSec}}s": "Resend code after {{countdownMin}}m{{countdownSec}}s",
	"Bạn đã yêu cầu OTP vượt quá số lần quy định": "You have requested OTP more than the allowed limit"
};

export { enLang as default };
